import { mapGetters } from 'vuex';
import { getCopyStakeGames, setPermissionGame } from '@/api/CopyStake/Game';
import { pluralize } from '@/helpers/pluralize';

import { ICopyStakeGameItemResponse, EGameSearchBy } from '@/api/schema';
import { errorToastMessage } from '@/helpers/errorToastMessage';

const defaultOptions = {
  page: 1,
  itemsPerPage: 10
};

const defaultFilter = {
  search: '',
  searchBy: EGameSearchBy.NAME
};
export default {
  data(): any {
    return {
      options: { ...defaultOptions },
      filters: { ...defaultFilter },
      rows: [],
      topGamesCount: null,
      totalElements: null,
      whitelisted: true,
      selectedItems: [],
      loading: false
    };
  },

  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    requestParams(): any {
      const { search, searchBy, providers } = this.filters;

      return {
        [searchBy]: search,
        permittedStates: this.whitelisted,
        page: this.options.page - 1,
        size: this.options.itemsPerPage,
        sort: 'name',
        order: 'asc',
        providers
      };
    },

    pluralizeSelectLabels(): string[] {
      return ['game', 'games', 'games'];
    },

    labelCountGames(): string {
      const count = this.selectedItems.length;

      if (!count) return '';

      return `${count} ${pluralize(count, this.pluralizeSelectLabels)}`;
    },

    formattedSelectedGames(): number[] {
      return this.selectedItems.map(
        (game: ICopyStakeGameItemResponse) => game.id
      );
    }
  },

  methods: {
    async updateGameList(): Promise<void> {
      try {
        this.loading = true;

        const response = await getCopyStakeGames(this.requestParams);

        this.rows = response.content;
        this.topGamesCount = response.topGamesCount;
        this.totalElements = response.totalElements;
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.loading = false;
      }
    },

    updateFilter(data: string[]): void {
      this.filters = { ...data };
    },

    resetFilter(): void {
      this.filters = { ...defaultFilter };
    },

    resetCurrentPage(): void {
      this.options.page = 1;
    },

    resetSelectedItems(): void {
      this.selectedItems = [];
    },

    setPermissionGames(): Promise<string> {
      return setPermissionGame(!this.whitelisted, this.formattedSelectedGames);
    }
  },

  watch: {
    filters: 'resetCurrentPage',
    requestParams: 'updateGameList'
  }
};
